import img1 from "../../images/coffeeshop.JPG";
import img2 from "../../images/mobile-php.JPG";
import img3 from "../../images/bookstorephp.JPG";

export default [
  {
    id: 1,
    name: "Nagi's Coffee-shop",
    description:
      "This is a coffeshop app using PHP. I have done login and registration aithentication.sending messages via php mailer",
    code_link: "https://github.com/nagireddy1234/coffeeShop-php/",
    deploy_link: "https://shielded-thicket-36277.herokuapp.com",
    tools: ["PHP", "Jquery", "Bootstrap", "CSS"],
    icons: ["fab", "PHP"],
    image: img1,
    image_describe: "Waves-Project",
  },
  {
    id: 2,
    name: "Mobie-store",
    description: "This is mobile shop app using PHP ",
    code_link: "https://github.com/nagireddy1234/E-commerce-php",
    deploy_link: "https://github.com/nagireddy1234/E-commerce-php",
    tools: ["PHP", "Jquery", "Bootstrap", "CSS"],
    icons: ["fab", "PHP"],
    image: img2,
    image_describe: "mobile-store-php",
  },

  {
    id: 3,
    name: "Book-Store",
    description: "This is Book store app and PHP CRUD operation are done",
    code_link: "https://github.com/nagireddy1234/BookStorePHP",
    deploy_link: "https://github.com/nagireddy1234/BookStorePHP",
    tools: ["PHP", "Javascript", "CSS"],
    icons: ["fab", "PHP"],
    image: img3,
    image_describe: "book-store-php",
  },
];
